import { useLang } from '../utils/hooks'
import { langImportFile } from '../assets/langImportFile'

const FileImportDiag = ({ diag }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langImportFile.fr : langImportFile.eng

  let diagList = []
  if (diag.time !== 0)
    diagList.push(<p>- {diag.time + choosenLang.importTime}</p>)
  if (diag.lat !== 0) diagList.push(<p>- {diag.lat + choosenLang.importLat}</p>)
  if (diag.lng !== 0) diagList.push(<p>- {diag.lng + choosenLang.importLng}</p>)
  /* if (diag.ele !== 0)
    diagList.push(<p>{diag.ele} n'ont pas d'info relative à l'altitude </p>) */
  if (diag.speed !== 0)
    diagList.push(<p>- {diag.speed + choosenLang.importSpeed}</p>)
  return (
    <div className="notification">
      <div className="block">
        <p>
          {choosenLang.import1}
          <span className="is-size-6 has-text-weight-medium has-text-link">
            {diag.fileName}
          </span>
          {choosenLang.import2}
        </p>
      </div>
      <div className="block">
        <p>
          {choosenLang.import3}
          <span className="is-size-6 has-text-weight-medium has-text-link">
            {diag.nb}
          </span>{' '}
          {choosenLang.import4}
        </p>
      </div>
      {diagList}
    </div>
  )
}

export default FileImportDiag
